import { useContext } from 'react';

import IsPlanWorkflowModalOpenContext from './context';
import { ContextValue } from './types';

const useIsPlanWorkflowModalOpen = (): ContextValue => {
  const context = useContext(IsPlanWorkflowModalOpenContext);

  if (context === null) {
    throw new Error(
      'useIsPlanWorkflowModalOpen must be used within a IsPlanWorkflowModalOpenProvider'
    );
  }

  return context;
};

export default useIsPlanWorkflowModalOpen;
